import React from 'react';
import GongqiFormItemControl from './GongqiFormItemControl';
import FormItemText from '../FormItemText';
import CmdTypeActions from '../../actions/CmdTypeActions';
import {CmdWriteControlStore} from '../../stores/CmdTypeStore';

export default class FormItemTextControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemTextControl";
		this.unsubscribeCmdWriteControlStore = CmdWriteControlStore.listen(this.onCmdWriteControlStore.bind(this));
	}

	getStyle()
	{
		let _style = super.getStyle();
		let propertyWidth = this.getProperty_Width();
		if(propertyWidth)
			_style["width"] = propertyWidth+"px";
		return _style;
	}

	getProperty_DisplayStyle()
	{
		if(this._castedDisplayStyle)
			return this._castedDisplayStyle;
		let _displayStyle = this.properties.DisplayStyle;
		try
		{
			_displayStyle = JSON.parse(_displayStyle);
		}
		catch(e)
		{

		}
		this._castedDisplayStyle = _displayStyle;
		return this._castedDisplayStyle;
	}

	getProperty_Alignment()
	{
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.HorizontalAlignment)
			return displayStyle.HorizontalAlignment;
		return this.properties.Alignment;
	}
	
	getProperty_AlignBase()
	{
		return this.properties.AlignBase;
	}
	
	getProperty_DisplayLength()
	{
		return this.properties.DisplayLength;
	}

	getProperty_DisplayHeight()
	{
		return this.properties.DisplayHeight;
	}

	setControlLabelCmd(value)
	{
		this._cmdLabel = value;
		CmdTypeActions.updateControlLabel(this.xml.name,value,this.module.instanceUUId);
	}

	onCmdWriteControlStore(arg,moduleInstanceId)
	{
		if(arg && arg.hasOwnProperty(this.xml.name) && this.module.instanceUUId == moduleInstanceId)
		{
			var value = arg[this.xml.name];
			this.initEditorValue = value;
		}
	}

	getComponentInstance(parent,forLookup)
	{
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();

		label = label.replace(/\\n/g,"<br/>");
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
	  	this.component = <FormItemText key={this.xml.id} xml={this.xml} alignMent={this.getProperty_Alignment()} moduleInstanceId={this.module.instanceUUId} 
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} alignBase={this.getProperty_AlignBase()}
                label={label} customStyle={this.getStyle()} menuItemId={this.menuItemId} formId={this.formId} displayLength={this.getProperty_DisplayLength()}
                control={this} displayHeight={this.getProperty_DisplayHeight()} initEditorValue={this.initEditorValue} {...commonProps}/>;
        return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemTextControl.js